// Checks for a file and type, protecting against folders/incorrect formats
function isCSVFileValid(file) {
  return file && file.name.split('.').pop().toLowerCase() === 'csv';
}

export { isCSVFileValid };
